var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"work-view"},[_c('h1',[_vm._v(_vm._s(_vm.title))]),_c('TheArticle',{class:'is-scrollable',attrs:{"article":_vm.article,"back":true}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }